class reservedJeweler extends HTMLElement {
  reservedJeweler = JSON.parse(sessionStorage.getItem('reservedJeweler') || '{}');

  async connectedCallback() {
    if (!this.reservedJeweler) return;

    await this.fetchJeweler();

    this.stepOneUrl = this.dataset.stepOneUrl;

    this.changeJewelerButton = this.querySelector('[data-change-jeweler]');
    this.changeJewelerButton.addEventListener('click', () => this.chooseAnotherJeweler());
  }

  async fetchJeweler() {
    try {
      const response = await fetch(`${this.reservedJeweler.url}?view=card`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const jewelerCard = html.querySelector('.jeweler-card');

      this.appendChild(jewelerCard);
    } catch (error) {
      console.error(error);
    }
  }

  chooseAnotherJeweler() {
    sessionStorage.removeItem('reservedJeweler');

    window.location = this.stepOneUrl;
  }
}

if (!customElements.get('reserved-jeweler')) {
  customElements.define('reserved-jeweler', reservedJeweler);
}
